import { ServerSubscriptionType } from '../../generated/graphql-types'

export const CARD_TYPES = {
  subscription: 1,
  giftCard: 2,
}

export interface SubscriptionType extends ServerSubscriptionType {
  type: 1 // CARD_TYPES.subscription
}
